import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';
import {PersonnelAuthority} from "./personnel-authority";

export class PersonnelDefinitionAuthority extends PersonnelAuthority {

    public static readonly PERSONNEL_DEF_BASE = "definition";

    constructor(authority: string) {
        super(combineAuth(PersonnelDefinitionAuthority.PERSONNEL_DEF_BASE, authority));
    }

}
